import { FaArrowUp } from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="relative mt-3 lg:mt-5 py-12 md:py-16 transition-colors duration-300" data-scroll-reveal>
      {/* Background with glass effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/50 to-white/30 backdrop-blur-sm" />
      <div className="absolute inset-0 border-t border-green-200/20" />

      {/* Content */}
      <div className="relative z-10">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
            <div className="col-span-1 md:col-span-3 flex justify-center">
              <button
                onClick={scrollToTop}
                className="flex items-center gap-2 text-sm font-semibold text-green-600 hover:text-green-700 group/scroll transition-colors"
              >
                Back to top
                <FaArrowUp className="opacity-0 group-hover/scroll:opacity-100 group-hover/scroll:-translate-y-1 transition-all duration-300" />
              </button>
            </div>
          </div>
          </div>

          {/* Gradient Divider */}
          <div className="h-px bg-gradient-to-r from-transparent via-green-400/30 to-transparent mb-6" />

          {/* Copyright */}
          <div className="text-center">
            <p className="text-sm text-gray-700 font-light">
              © {currentYear} Stili Ikram. Crafted with{" "}
              <span className="text-green-600">creativity</span> and{" "}
              <span className="text-green-600">code</span>.
            </p>
          </div>
        </div>
    </footer>
  );
};

export default Footer;
